import cn from 'classnames';
import PropTypes from 'prop-types';

import { AnalyticsSpinnerImage } from './AnalyticsSpinnerImage';

import styles from './AnalyticsSpinner.module.scss';

export function AnalyticsSpinner({ fullScreen }) {
  return (
    <div className={cn(styles.analyticsSpinnerWrapper, fullScreen ? styles.fullScreen : '')}>
      <div className={styles.imageWrapper}>
        <AnalyticsSpinnerImage />
      </div>
    </div>
  );
}

AnalyticsSpinner.propTypes = {
  fullScreen: PropTypes.bool,
};
